import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom';

const defaultProps = {
    title: 'MessageBox',
    content: <></>,
    container: '#app-message-box',
    buttons: []
};

export default {
    open: (props) => {
        return new Promise((resolve) => {
            const { title, content, container, buttons } = {
                ...defaultProps,
                ...props
            };
            const containerElement = document.querySelector(container);
            if (!containerElement) throw Error(`can't find container ${container}`);

            const handleClose = (value) => {
                let result = null;
                if (value && !value.target) {
                    result = value;
                }
                ReactDOM.unmountComponentAtNode(containerElement);
                return resolve(result);
            };

            const handleButton = (handler) => () => {
                handleClose(handler());
            };

            ReactDOM.render(
                // <Modal title={title} onClose={handleClose}>
                //     {content}
                //     {buttons.map((btn) => {
                //         return (
                //             <button onClick={handleButton(btn.handler)} key={btn.name}>
                //                 {btn.name}
                //             </button>
                //         );
                //     })}
                // </Modal>,
                <Dialog
                    open={true}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    disableEnforceFocus
                >
                    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                    <DialogContent>
                        {content}
                        {/* <DialogContentText id="alert-dialog-description">{content}</DialogContentText> */}
                    </DialogContent>
                    <DialogActions>
                        {/* <Button color="secondary" onClick={handleClose}>
                            No
                        </Button> */}
                        {buttons.map((btn) => {
                            return (
                                <Button onClick={handleButton(btn.handler)} key={btn.name} color={btn.color}>
                                    {btn.name}
                                </Button>
                            );
                        })}
                        {/* <Button color="secondary" onClick={handleClose}>
                            Disagree
                        </Button>
                        <Button color="error" startIcon={<ThumbDownIcon />} onClick={SubmitDelete} autoFocus>
                            Agree
                        </Button> */}
                    </DialogActions>
                </Dialog>,
                containerElement
            );
        });
    }
};
